export default function ApplicationHistoryTab() {
  return <div>Application History</div>
}
